import React from 'react'
import moment from 'moment'

import { DealDeprecatedHistoryNode } from '@/apollo/graphql'

const HistoryRow: React.FC<{
  node: DealDeprecatedHistoryNode
  onClick: (node: DealDeprecatedHistoryNode) => void
}> = ({ node, onClick }) => {
  return (
    <tr onClick={() => onClick(node)}>
      <td>{node.fieldName}</td>
      <td>{node.oldValue}</td>
      <td>{node.newValue}</td>
      <td>{moment(node.updateTime).format('DD.MM.YYYY, HH:mm')}</td>
      <td>
        <b>{node.updateUser?.username}</b>
      </td>
    </tr>
  )
}

export default HistoryRow
